module.exports = __webpack_public_path__ + "static/media/program.93d7e6ec.png";